











import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "timeline-table": () =>
      import("@/components/app/global/timelineComponent/timelineTable.vue")
  }
})
export default class PromotionActivityView extends Vue {
  public get promotionId() {
    return this.$route.params.promotionId;
  }
}
